import { atom } from "recoil"

export const matchingGroupState = atom<boolean>({
  key: "atoms/sidebar/matchingGroupState",
  default: false,
})
